import {GraphType} from "../../../../../gd-modules/dashboard/widgets/constants/types";
import GroupBy from "../../../../../gd/manager/group-by/group-by-model";


export default class ReportTasksChart_Settings {

    public projectIds       : ID[] | null
    public graphType        : GraphType

    // public groupBy          : ID    // field we group by
    // public counterType      : CounterType

    public dimensionGroupBy : GroupBy
    // public dimensionFieldId : ID    // field we group by
    public metricFieldId    : ID    // field we calculate based on (“the number you’re aggregating”)

    public includeSubtasks  : boolean
    public showClosedTasks  : boolean

    public reportTitle      : string = ''


    constructor(data: any) {
        this.projectIds         = _.get(data, "projectIds", [])
        this.graphType          = _.get(data, "graphType", GraphType.BAR)


        const groupByConfig     = _.get(data, "dimensionGroupBy", {
            fieldId               : gd.fields.task.statusId.fieldId,
            // sortDirection       : SortDirection.ASC
        })
        this.dimensionGroupBy   = new GroupBy(groupByConfig)

        // this.dimensionFieldId   = _.get(data, "dimensionFieldId", gd.fields.task.statusId.fieldId)
        this.metricFieldId      = _.get(data, "metricFieldId", gd.fields.task.taskCounter.fieldId)

        this.includeSubtasks    = _.get(data, "includeSubtasks", true)
        this.showClosedTasks    = _.get(data, "showClosedTasks", true)

    }

    toJSON(): JSONObject {
        const result: JSONObject = {
            projectIds          : this.projectIds,
            graphType           : this.graphType,

            dimensionGroupBy    : this.dimensionGroupBy.toJSON(),
            // dimensionFieldId    : this.dimensionFieldId,
            metricFieldId       : this.metricFieldId,

            includeSubtasks     : this.includeSubtasks,
            showClosedTasks     : this.showClosedTasks
        }

        return result
    }
}
